<ng-template #errorCampo let-ruta="ruta">
  <div class="cf-field__error" [class.m184d-aviso]="m.type === 'WARNING'" *ngIf="mensaje(ruta) as m">
    <mat-icon>{{ m.type === 'WARNING' ? 'warning' : 'error' }}</mat-icon> {{ m.message }}
  </div>
</ng-template>

<ng-template #texto let-ruta="ruta" let-etiqueta="etiqueta" let-requerido="requerido" let-max="max" let-span="span">
  <div class="m184d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido"
    [class.cf-field--invalid]="!!mensaje(ruta)">
    <app-ui-input [attr.id]="'rentas.' + ruta" [ngModel]="f[ruta]" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, maxLength: max }"></app-ui-input>
    <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: ruta }"></ng-container>
  </div>
</ng-template>

<ng-template #numero let-ruta="ruta" let-etiqueta="etiqueta" let-requerido="requerido" let-entero="entero" let-span="span">
  <div class="m184d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido"
    [class.cf-field--invalid]="!!mensaje(ruta)">
    <app-ui-input [attr.id]="'rentas.' + ruta" [ngModel]="f[ruta]" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, type: 'number', step: entero ? '1' : '0.01', inputmode: entero ? 'numeric' : 'decimal' }"></app-ui-input>
    <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: ruta }"></ng-container>
  </div>
</ng-template>

<ng-template #seleccion let-ruta="ruta" let-etiqueta="etiqueta" let-opciones="opciones" let-requerido="requerido" let-span="span">
  <div class="m184d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido"
    [class.cf-field--invalid]="!!mensaje(ruta)">
    <app-select [attr.id]="'rentas.' + ruta" [ngModel]="f[ruta]" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, options: opciones, placeholder: 'Seleccionar' }"></app-select>
    <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: ruta }"></ng-container>
  </div>
</ng-template>

<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>account_balance</mat-icon>
    </div>
    <div class="m184d-header-text">
      <h2 class="cf-dlg-title">{{ titulo }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitulo }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="cerrar()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="saving" message="Guardando la renta…"></app-loading-state>

  <ng-container *ngIf="!saving">
    <div class="cf-dlg-body">

      <div class="m184d-alert m184d-alert--error" *ngIf="sueltas.length">
        <mat-icon>error</mat-icon>
        <div>
          <div *ngFor="let item of sueltas; trackBy: trackByIndex">{{ item.message }}</div>
        </div>
      </div>

      <div class="m184d-vistas">
        <button type="button" class="m184d-vista" [class.m184d-vista--activa]="vista === 'renta'"
          (click)="vista = 'renta'">Renta</button>
        <button type="button" class="m184d-vista" [class.m184d-vista--activa]="vista === 'gastos'"
          (click)="vista = 'gastos'">Detalle de gastos</button>
      </div>

      <fieldset class="m184d-fs">

        <ng-container *ngIf="vista === 'renta'">

          <div class="m184d-box">
            <h6 class="m184d-box__title">Clave de la renta</h6>
            <div class="m184d-grid">
              <div class="m184d-field" style="grid-column: span 5;" [class.cf-field--required]="true"
                [class.cf-field--invalid]="!!mensaje('clave')">
                <app-select id="rentas.clave" [ngModel]="f.clave" (ngModelChange)="cambiarClave($event)"
                  [config]="{ label: 'Clave', options: claveOptions, placeholder: 'Seleccionar' }"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: 'clave' }"></ng-container>
              </div>
              <div class="m184d-field" style="grid-column: span 5;" [class.cf-field--invalid]="!!mensaje('subclave')">
                <app-select id="rentas.subclave" [ngModel]="f.subclave" (ngModelChange)="set('subclave', $event)"
                  [disabled]="!subclaveOptions.length" [config]="subclaveConfig"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: 'subclave' }"></ng-container>
              </div>
              <ng-container *ngTemplateOutlet="texto; context: { ruta: 'pais', etiqueta: 'Clave de país', max: 2, span: 2 }"></ng-container>
            </div>
          </div>

          <div class="m184d-box">
            <h6 class="m184d-box__title">Importes</h6>
            <div class="m184d-grid">
              <ng-container *ngTemplateOutlet="numero; context: { ruta: 'ingresos', etiqueta: 'Ingresos o rendimientos devengados', span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="numero; context: { ruta: 'gastos', etiqueta: 'Gastos', span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="numero; context: { ruta: 'renta', etiqueta: 'Renta atribuible', span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="numero; context: { ruta: 'porcentajeReduccion', etiqueta: 'Porcentaje de reducción', span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="numero; context: { ruta: 'rentaReduccion', etiqueta: 'Renta con derecho a reducción', span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="numero; context: { ruta: 'gananciasPerdidas', etiqueta: 'Ganancias o pérdidas patrimoniales', span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="numero; context: { ruta: 'baseDeduccion', etiqueta: 'Base de deducción', span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="numero; context: { ruta: 'retenciones', etiqueta: 'Retenciones e ingresos a cuenta', span: 3 }"></ng-container>
            </div>
          </div>

          <div class="m184d-box">
            <h6 class="m184d-box__title">Actividades económicas</h6>
            <div class="m184d-grid">
              <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'regimen', etiqueta: 'Régimen de determinación', opciones: regimenOptions, span: 5 }"></ng-container>
              <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'tipoActividad', etiqueta: 'Tipo de actividad', opciones: tipoActividadOptions, span: 5 }"></ng-container>
              <ng-container *ngTemplateOutlet="texto; context: { ruta: 'iae', etiqueta: 'Grupo o epígrafe IAE', max: 4, span: 2 }"></ng-container>
              <div class="m184d-field" style="grid-column: span 3;">
                <app-select id="rentas.criterioCobros" [ngModel]="f.criterioCobrosSN" (ngModelChange)="f.criterioCobrosSN = $event"
                  [config]="{ label: 'Criterio de cobros y pagos', options: sinoOptions }"></app-select>
              </div>
            </div>
          </div>

          <div class="m184d-box">
            <h6 class="m184d-box__title">Cesionario de capitales y rentas de instituciones de inversión colectiva</h6>
            <div class="m184d-grid">
              <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nifCesionario', etiqueta: 'NIF del cesionario o de la institución', max: 9, span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="texto; context: { ruta: 'denominacionCesionario', etiqueta: 'Denominación', max: 20, span: 5 }"></ng-container>
              <div class="m184d-field" style="grid-column: span 4;" [class.cf-field--invalid]="!!mensaje('fechaAdquisicion')">
                <app-date id="rentas.fechaAdquisicion" [control]="fechaControl"
                  [config]="{ label: 'Fecha de adquisición o suscripción' }"></app-date>
                <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: 'fechaAdquisicion' }"></ng-container>
              </div>
              <ng-container *ngTemplateOutlet="numero; context: { ruta: 'valorAumentos', etiqueta: 'Valor liquidativo o ajustes: aumentos', span: 4 }"></ng-container>
              <ng-container *ngTemplateOutlet="numero; context: { ruta: 'valorDisminuciones', etiqueta: 'Valor de adquisición o ajustes: disminuciones', span: 4 }"></ng-container>
            </div>
          </div>

          <div class="m184d-box">
            <h6 class="m184d-box__title">Inmueble</h6>
            <div class="m184d-grid">
              <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'situacionInmueble', etiqueta: 'Situación del inmueble', opciones: situacionOptions, span: 5 }"></ng-container>
              <ng-container *ngTemplateOutlet="texto; context: { ruta: 'referenciaCatastral', etiqueta: 'Referencia catastral', max: 20, span: 4 }"></ng-container>
              <ng-container *ngTemplateOutlet="numero; context: { ruta: 'diasArrendamiento', etiqueta: 'Días de arrendamiento', entero: true, span: 3 }"></ng-container>
            </div>
          </div>

        </ng-container>

        <ng-container *ngIf="vista === 'gastos'">

          <div class="m184d-box">
            <h6 class="m184d-box__title">Gastos de actividades económicas</h6>
            <div class="m184d-grid">
              <div class="m184d-field" style="grid-column: span 4;" *ngFor="let gasto of gastosActividad; trackBy: trackByIndex">
                <app-ui-input [(ngModel)]="f.gastosActividad[gasto.clave]"
                  [config]="{ label: gasto.etiqueta, type: 'number', step: '0.01', inputmode: 'decimal' }"></app-ui-input>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: 'gastosActividad' }"></ng-container>
          </div>

          <div class="m184d-box">
            <h6 class="m184d-box__title">Gastos del capital inmobiliario</h6>
            <div class="m184d-grid">
              <div class="m184d-field" style="grid-column: span 4;" *ngFor="let gasto of gastosInmueble; trackBy: trackByIndex">
                <app-ui-input [(ngModel)]="f.gastosInmueble[gasto.clave]"
                  [config]="{ label: gasto.etiqueta, type: 'number', step: '0.01', inputmode: 'decimal' }"></app-ui-input>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: 'gastosInmueble' }"></ng-container>
          </div>

        </ng-container>

      </fieldset>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cerrar()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="guardar()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>
  </ng-container>
</div>
